/* Athletic Air · vista de cerca (fotos reales, giro suave) */
(function () {
  if (window.AAViewerReady) return;
  window.AAViewerReady = true;
  var REDUCE = false;
  try { REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var TXT = {
    es: { views: ['Un lado', 'Otro lado', 'Vista 3'], drag: 'Desliza para girar', tilt: 'Mueve el cursor para ver el volumen', color: 'Color' },
    en: { views: ['One side', 'Other side', 'View 3'], drag: 'Swipe to turn', tilt: 'Move your cursor to see its shape', color: 'Colour' }
  };
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  /* Group the product photos by colour: up to 3 photos per colour. */
  function groups(d) {
    var imgs = d.images, cols = d.colors, n = imgs.length, k = cols.length;
    if (!k) return [{ name: '', idx: imgs.slice(0, 3).map(function (_, i) { return i; }) }];
    function block(size) { return cols.map(function (c, i) { var a = []; for (var j = 0; j < size && j < 3; j++) a.push(i * size + j); return { name: c.name, idx: a }; }); }
    if (n === 3 * k) return block(3);
    if (n === 2 * k) return block(2);
    if (n === k) return block(1);
    var starts = cols.map(function (c) { return c.start; });
    var ok = starts.every(function (s) { return s; }) && new Set(starts).size === starts.length;
    if (ok) {
      var sorted = starts.slice().sort(function (a, b) { return a - b; });
      return cols.map(function (c) {
        var s = c.start, next = sorted.filter(function (x) { return x > s; })[0], end = next ? next - 1 : n, a = [];
        for (var p = s; p <= Math.min(end, s + 2); p++) a.push(p - 1);
        return { name: c.name, idx: a };
      });
    }
    var per = Math.max(1, Math.floor(n / k));
    return cols.map(function (c, i) { var a = []; for (var j = 0; j < Math.min(per, 3); j++) if (i * per + j < n) a.push(i * per + j); return { name: c.name, idx: a.length ? a : [0] }; });
  }

  function Viewer(root) {
    var d = JSON.parse(root.querySelector('[data-aa-viewer-data]').textContent);
    var t = TXT[d.lang] || TXT.es;
    var G = groups(d), stage = root.querySelector('[data-aa-stage]'), tilt = root.querySelector('[data-aa-tilt]'), shadow = root.querySelector('[data-aa-shadow]');
    var viewsEl = root.querySelector('[data-aa-views]'), colorsEl = root.querySelector('[data-aa-colors]'), hint = root.querySelector('[data-aa-hint]');
    var st = { c: 0, p: 0, tx: 0, ty: 0, raf: null, layers: [] };

    function build() {
      st.layers.forEach(function (l) { l.remove(); }); st.layers = [];
      var g = G[st.c];
      g.idx.forEach(function (i) {
        var im = document.createElement('img');
        im.className = 'aa-viewer__ly'; im.src = d.images[i].src; im.alt = ''; im.decoding = 'async'; im.draggable = false;
        tilt.appendChild(im); st.layers.push(im);
      });
      stage.setAttribute('aria-label', d.images[g.idx[0]].alt + (g.name ? ' · ' + g.name : ''));
      viewsEl.innerHTML = g.idx.length > 1 ? g.idx.map(function (_, k) { return '<button type="button" data-k="' + k + '">' + t.views[k] + '</button>'; }).join('') : '';
      hint.textContent = g.idx.length > 1 ? t.drag : t.tilt;
      st.p = 0; draw();
    }
    function colors() {
      if (G.length < 2) { colorsEl.hidden = true; return; }
      colorsEl.innerHTML = '<span>' + t.color + '</span>' + G.map(function (g, i) {
        return '<button type="button" data-c="' + i + '" aria-label="' + g.name.replace(/"/g, '&quot;') + '" aria-pressed="' + (i === st.c) + '"><img src="' + d.images[g.idx[0]].src.replace(/width=\d+/, 'width=160') + '" alt="" loading="lazy"></button>';
      }).join('');
    }
    function draw() {
      var n = st.layers.length;
      st.layers.forEach(function (l, k) {
        var dd = st.p - k, ad = Math.abs(dd), op = Math.max(0, 1 - ad);
        l.style.opacity = op.toFixed(3);
        l.style.transform = 'translateX(' + (-dd * 5) + '%) rotateY(' + (-dd * 9) + 'deg) scale(' + (1 - Math.min(ad, 1) * .04) + ')';
      });
      var frac = Math.abs(st.p - Math.round(st.p));
      tilt.style.transform = 'rotateX(' + st.ty.toFixed(2) + 'deg) rotateY(' + st.tx.toFixed(2) + 'deg)';
      shadow.style.transform = 'translateX(' + (st.tx * -1.2).toFixed(1) + '%) scaleX(' + (1 - frac * .25).toFixed(3) + ')';
      viewsEl.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.k === Math.round(st.p)); });
    }
    function to(target, dur) {
      cancelAnimationFrame(st.raf);
      if (REDUCE) { st.p = target; draw(); return; }
      var from = st.p, s0 = null; dur = dur || 900;
      function step(ts) { if (s0 === null) s0 = ts; var q = Math.min(1, (ts - s0) / dur); st.p = from + (target - from) * ease(q); draw(); if (q < 1) st.raf = requestAnimationFrame(step); }
      st.raf = requestAnimationFrame(step);
    }
    viewsEl.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) to(+b.dataset.k); });
    viewsEl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var k = Math.max(0, Math.min(st.layers.length - 1, Math.round(st.p) + (e.key === 'ArrowRight' ? 1 : -1)));
      to(k); var b = viewsEl.querySelector('[data-k="' + k + '"]'); if (b) b.focus();
    });
    colorsEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      st.c = +b.dataset.c; colorsEl.querySelectorAll('button').forEach(function (x, i) { x.setAttribute('aria-pressed', i === st.c); }); build();
    });

    /* Horizontal drag turns between real photos; vertical swipes keep scrolling the page. */
    var drag = null;
    stage.addEventListener('pointerdown', function (e) { cancelAnimationFrame(st.raf); drag = { x: e.clientX, y: e.clientY, p: st.p, w: stage.clientWidth, live: e.pointerType === 'mouse', id: e.pointerId }; });
    window.addEventListener('pointermove', function (e) {
      if (drag) {
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (!drag.live) { if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.3) drag.live = true; else if (Math.abs(dy) > 10) { drag = null; return; } else return; }
        if (!stage.classList.contains('is-drag')) { stage.classList.add('is-drag'); try { stage.setPointerCapture(drag.id); } catch (x) {} }
        if (st.layers.length > 1) st.p = Math.max(0, Math.min(st.layers.length - 1, drag.p - dx / (drag.w * .75)));
        st.tx = Math.max(-5, Math.min(5, dx / drag.w * 10)); draw(); return;
      }
      if (e.pointerType !== 'mouse' || REDUCE || !stage.contains(e.target)) return;
      var r = stage.getBoundingClientRect();
      st.tx = ((e.clientX - r.left) / r.width - .5) * 8; st.ty = -((e.clientY - r.top) / r.height - .5) * 6; draw();
    });
    stage.addEventListener('pointerleave', function () { if (!drag) { st.tx = 0; st.ty = 0; draw(); } });
    function end() { if (!drag) return; stage.classList.remove('is-drag'); drag = null; st.tx = 0; st.ty = 0; to(Math.round(st.p), 600); }
    window.addEventListener('pointerup', end); window.addEventListener('pointercancel', end);

    /* Optional: turn softly with the page scroll (used on the home spotlight). */
    if (root.hasAttribute('data-aa-scroll') && !REDUCE) {
      var touched = false;
      root.addEventListener('pointerdown', function () { touched = true; }, { passive: true });
      viewsEl.addEventListener('click', function () { touched = true; });
      window.addEventListener('scroll', function () {
        if (touched || drag || st.layers.length < 2) return;
        var r = root.getBoundingClientRect(), vh = window.innerHeight || 800;
        var q = Math.max(0, Math.min(1, (vh * .75 - r.top) / (r.height * .9)));
        st.p = ease(q) * (st.layers.length - 1); draw();
      }, { passive: true });
    }
    colors(); build();
  }

  function init(scope) { (scope || document).querySelectorAll('[data-aa-viewer]:not([data-ready])').forEach(function (el) { el.setAttribute('data-ready', ''); try { Viewer(el); } catch (e) { console.warn('aa-viewer', e); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
